// extracted by mini-css-extract-plugin
export default {"placeholder":"Prefs_placeholder__OneIz","targetProfileicon":"Prefs_targetProfileicon__Wdofx"};